import SearchIcon from "components/icons/SearchIcon";
import { MdAdd } from "react-icons/md";
import { useTranslation } from "react-i18next";
import { useAuthContext } from "auth/AuthProvider";

interface SearchProps {
  value: string;
  onChange: (value: string) => void;
  onNew: () => void;
}

const Search = ({ value, onChange, onNew }: SearchProps) => {
  const { t } = useTranslation();
  const { user } = useAuthContext();

  const isCreatePackage = user.is_super_admin;

  return (
    <div className="mx-auto mt-5 flex w-full gap-4 overflow-hidden md:!gap-6">
      <div className="flex h-[45px] w-full rounded-xl border !border-gray-200 dark:!border-none dark:!bg-navy-700">
        <SearchIcon />
        <input
          placeholder={t("marketplace.searchPackagesPlaceholder")}
          className="!w-full rounded-xl text-sm font-medium outline-none dark:bg-navy-700 dark:text-white"
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
      </div>
      {isCreatePackage && (
        <button
          onClick={onNew}
          className="linear flex items-center justify-center gap-2 rounded-xl bg-brand-500 px-4 text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700"
        >
          <MdAdd className="text-xl" />
          <span className="whitespace-nowrap">
            {t("marketplace.newPackage")}
          </span>
        </button>
      )}
    </div>
  );
};

export default Search;
